<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo" :to="{name : 'login'}">
        <b-img :src="appLogoImage" :alt="'Logo ' + appName" width="40" height="40"/>
        <h2 class="brand-text text-primary m-auto pl-1">{{ appName }}</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5" >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Forgot password V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5" >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto" >
          <b-card-title class="mb-1"> {{ $t('Forgot Password? 🔒') }} </b-card-title>
          <b-card-text class="mb-2"> {{ $t("Enter your email and we'll send you instructions to reset your password") }} </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form class="auth-forgot-password-form mt-2" @submit.prevent="validationForm" >
              <b-form-group :label="$t('Email')" label-for="forgot-password-email" >
                <validation-provider #default="{ errors }" :name="$t('email')" rules="required|email" >
                  <b-form-input id="forgot-password-email" v-model="userEmail" :state="errors.length > 0 ? false : null" name="forgot-password-email" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button type="submit" variant="primary" block > {{ $t('Send reset link') }} </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2"> <b-link :to="{name:'login'}"> <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to login') }} </b-link> </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton } from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import { $themeConfig } from '@themeConfig'
import i18n from '@/libs/i18n'

export default {
  components: { BRow, BCol, BLink, BImg, BForm, BButton, BFormGroup, BFormInput, BCardTitle, BCardText, ValidationProvider, ValidationObserver, },
  data() {
    return {
      userEmail: '',
      sideImg: require('@/assets/images/pages/forgot-password.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/forgot-password-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {

          useJwt
          .forgotPassword({
            email: this.userEmail,
            local: localStorage.getItem("locale")
          })
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: i18n.t("Email sent successfully"),
                icon: 'EditIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: i18n.t("Error on sent email"),
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          })

        }
      })
    },
  },
  setup(){
    const { appName, appLogoImage } = $themeConfig.app
    return { appName, appLogoImage, }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-auth.scss';
</style>
